import { ExceptionsClient } from "../client/ExceptionsClient";

export function checkEligibility({scrubType}, dispatcher) {
    ExceptionsClient.getStartScrubEligibility({
        scrubType : scrubType
    }).then(({valid, data}) => {
        if(valid) {
            dispatcher({
                type: "SET_ELIGIBILITY",
                data: data
            });
        } else{
            dispatcher({
                type: "SET_ELIGIBILITY",
                data: {eligibilityStatus:"ERROR", metaData:{messageStringId:"check_eligibility_failure"}}
            });
        }

    });
}


// WEBPACK FOOTER //
// ./src/commons/api/GetStartScrubEligibility.js